import * as React from 'react';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { columnName, tableName } from 'app/area/case/case-data-model';

type CurrentUser = { value: string | number; description?: string };

type WithEntryTimeRecordedByDefaultOwnProps = {
  currentUser?: CurrentUser;
  onAddDocumentItem?: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
};

/**
 * When a new entry log row is added, defaults the `EntryLogEntryTimeRecordedBy` field
 * to the current user, unless a value has already been provided (e.g. by the caller).
 */
export const withEntryTimeRecordedByDefault = <P extends WithEntryTimeRecordedByDefaultOwnProps>(
  WrappedComponent: React.ComponentClass<P> | React.FC<P>
) => {
  return class extends React.PureComponent<P> {
    private onAddDocumentItem = (selectAddedItem?: boolean, options: AddDocumentItemOptions = {}) => {
      const fieldName = columnName[tableName.involvedPersonEntryLog].entryTimeRecordedBy;
      const existingValue = options.initialValues && (options.initialValues as any)[fieldName];
      const currentUser = this.props.currentUser;

      const initialValues = !existingValue && currentUser
        ? {
          ...options.initialValues,
          [fieldName]: [{ value: currentUser.value, description: currentUser.description }]
        }
        : options.initialValues;

      this.props.onAddDocumentItem &&
        this.props.onAddDocumentItem(selectAddedItem, { ...options, initialValues });
    };

    public render() {
      return <WrappedComponent {...this.props as P} onAddDocumentItem={this.onAddDocumentItem} />;
    }
  };
};
